import { endpoint, env, getAuthToken, handleUnauthorized } from '@eruvaka/web-pondlogs-base';
const api = (path) => endpoint(env.apiBaseUrl, path);
const handleError = async (res, fallback) => {
    if (res.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized');
    }
    let message = fallback;
    try {
        const body = (await res.json());
        message = body.message ?? body.error ?? fallback;
    }
    catch {
        // ignore parse errors
    }
    throw new Error(message);
};
const authFetch = async (url, options = {}) => {
    const token = getAuthToken();
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });
};
const toTitleCase = (str) => str.replace(/\b\w/g, (c) => c.toUpperCase());
export const fetchCountries = async () => {
    const res = await authFetch(api('/api/v3/countries'));
    if (!res.ok)
        return handleError(res, 'Failed to fetch countries');
    const body = (await res.json());
    return (body.countries ?? [])
        .map((country) => ({
        name: toTitleCase((country.country_name ?? '').trim()),
        code: (country.country_code ?? '').trim().toUpperCase(),
    }))
        .filter((country) => Boolean(country.name) && Boolean(country.code));
};
export const fetchTimezones = async (countryCode) => {
    const normalizedCountryCode = countryCode.trim().toUpperCase();
    if (!normalizedCountryCode)
        return [];
    const res = await authFetch(api(`/api/v3/countries/${encodeURIComponent(normalizedCountryCode)}/timezones`));
    if (!res.ok)
        return handleError(res, 'Failed to fetch timezones');
    const body = (await res.json());
    return (body.timezones ?? [])
        .map((timezone) => ({
        name: (timezone.name ?? '').trim(),
        offset: Number.isFinite(timezone.offset) ? Number(timezone.offset) : 0,
    }))
        .filter((timezone) => Boolean(timezone.name));
};
